


















































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'Privacy',
})
export default class Privacy extends Vue {}
